import { render, staticRenderFns } from "./profession-list.vue?vue&type=template&id=31551c1c&scoped=true&"
import script from "./profession-list.vue?vue&type=script&lang=js&"
export * from "./profession-list.vue?vue&type=script&lang=js&"
import style0 from "./profession-list.vue?vue&type=style&index=0&id=31551c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31551c1c",
  null
  
)

export default component.exports